import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { useClientTranslations } from "../../lib/i18n/client";
import type { EducationContent } from "../../services/educationService";
import { ContentCard } from "./ContentCard";
import styles from "./RecommendedContent.module.css";

interface RecommendedContentProps {
	items: EducationContent[];
}

export function RecommendedContent({ items }: RecommendedContentProps) {
	const { direction } = useClientTranslations("education");

	return (
		<div className={styles.container}>
			<Swiper
				modules={[Pagination]}
				slidesPerView="auto"
				spaceBetween={12}
				pagination={{ clickable: true }}
				dir={direction}
				threshold={10}
				touchStartPreventDefault={false}
				resistanceRatio={0.65}
				className={styles.swiper}
			>
				{items.map((item, index) => (
					<SwiperSlide key={item.id} className={styles.slide}>
						<ContentCard content={item} index={index} />
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
}
